(function () {
  var SECTION_SELECTOR = "[data-pam-logo-list]";
  var MOBILE_QUERY = "(max-width: 749px)";
  var REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
  var mobileMedia = window.matchMedia(MOBILE_QUERY);
  var reducedMotionMedia = window.matchMedia(REDUCED_MOTION_QUERY);
  var resizeTimer = null;

  function toBoolean(value) {
    return value === "true";
  }

  function toNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function shouldUseSlider(section) {
    var layoutMode = section.dataset.layoutMode;

    if (layoutMode === "slider") {
      return true;
    }

    if (layoutMode === "mobileSlider") {
      return mobileMedia.matches;
    }

    return false;
  }

  function destroySlider(section) {
    var viewport = section.querySelector(".pam-logoListViewport");

    if (viewport && viewport.swiper) {
      viewport.swiper.destroy(true, true);
    }

    section.classList.remove("pam-logoList--sliderActive");
  }

  function getSlidesPerView(section, key, fallback) {
    return Math.max(1, Math.round(toNumber(section.dataset[key], fallback)));
  }

  function initLogoList(section) {
    var viewport = section.querySelector(".pam-logoListViewport");
    var items = section.querySelectorAll(".pam-logoListItem");

    destroySlider(section);

    if (!viewport || !shouldUseSlider(section) || !window.Swiper || items.length === 0) {
      return;
    }

    var desktopColumns = getSlidesPerView(section, "desktopColumns", 6);
    var tabletColumns = getSlidesPerView(section, "tabletColumns", 3);
    var mobileColumns = getSlidesPerView(section, "mobileColumns", 2);
    var gap = Math.max(0, toNumber(section.dataset.gap, 16));
    var speed = Math.max(0, toNumber(section.dataset.speed, 600));
    var autoplayDelay = Math.max(1000, toNumber(section.dataset.autoplayDelay, 4) * 1000);
    var arrows = toBoolean(section.dataset.arrows);
    var dots = toBoolean(section.dataset.dots);
    var draggable = toBoolean(section.dataset.draggable);
    var maxVisibleSlides = section.dataset.layoutMode === "mobileSlider"
      ? mobileColumns
      : Math.max(desktopColumns, tabletColumns, mobileColumns);
    var loop = toBoolean(section.dataset.loop) && items.length > maxVisibleSlides;
    var autoplay = toBoolean(section.dataset.autoplay) && !reducedMotionMedia.matches;
    var prevButton = section.querySelector(".pam-logoListButton--prev");
    var nextButton = section.querySelector(".pam-logoListButton--next");
    var pagination = section.querySelector(".pam-logoListPagination");

    var config = {
      slidesPerView: Math.min(mobileColumns, items.length),
      spaceBetween: gap,
      speed: speed,
      loop: loop,
      watchOverflow: true,
      allowTouchMove: draggable,
      simulateTouch: draggable,
      grabCursor: draggable,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      breakpoints: {
        750: {
          slidesPerView: Math.min(tabletColumns, items.length),
          spaceBetween: gap,
        },
        990: {
          slidesPerView: Math.min(desktopColumns, items.length),
          spaceBetween: gap,
        },
      },
    };

    if (autoplay) {
      config.autoplay = {
        delay: autoplayDelay,
        disableOnInteraction: false,
        pauseOnMouseEnter: toBoolean(section.dataset.pauseOnHover),
      };
    }

    if (arrows && prevButton && nextButton) {
      config.navigation = {
        prevEl: prevButton,
        nextEl: nextButton,
      };
    }

    if (dots && pagination) {
      config.pagination = {
        el: pagination,
        clickable: true,
      };
    }

    new Swiper(viewport, config);
    section.classList.add("pam-logoList--sliderActive");
  }

  function initAllLogoLists(context) {
    var scope = context || document;
    var sections = scope.matches && scope.matches(SECTION_SELECTOR)
      ? [scope]
      : Array.prototype.slice.call(scope.querySelectorAll(SECTION_SELECTOR));

    sections.forEach(initLogoList);
  }

  function refreshLogoLists() {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      initAllLogoLists(document);
    }, 150);
  }

  document.addEventListener("DOMContentLoaded", function () {
    initAllLogoLists(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    initAllLogoLists(event.target);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var sections = event.target.matches && event.target.matches(SECTION_SELECTOR)
      ? [event.target]
      : Array.prototype.slice.call(event.target.querySelectorAll(SECTION_SELECTOR));

    sections.forEach(destroySlider);
  });

  if (mobileMedia.addEventListener) {
    mobileMedia.addEventListener("change", refreshLogoLists);
    reducedMotionMedia.addEventListener("change", refreshLogoLists);
  } else if (mobileMedia.addListener) {
    mobileMedia.addListener(refreshLogoLists);
    reducedMotionMedia.addListener(refreshLogoLists);
  }
})();
